import { render, staticRenderFns } from "./BixImg.vue?vue&type=template&id=29970e71&scoped=true&"
import script from "./BixImg.vue?vue&type=script&lang=ts&"
export * from "./BixImg.vue?vue&type=script&lang=ts&"
import style0 from "./BixImg.vue?vue&type=style&index=0&id=29970e71&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29970e71",
  null
  
)

export default component.exports